module.exports = {
  __depends__: [
    require(108),
    require(159),
    require(141),
    require(155),
    require(106)
  ],
  __init__: [ 'move', 'moveVisuals' ],
  move: [ 'type', require(137) ],
  moveVisuals: [ 'type', require(138) ]
};
